/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import star from '../assets/images/yellow_star.svg';
import arrow from '../assets/images/chevron-down.svg';
import arrowUp from '../assets/images/chevron-up.svg';
import plus from '../images/plus_color.svg';
import NewQuestion from './NewQuestion';
import Diamond from '../assets/images/diamond_gray.svg';
import { useNavigate } from 'react-router-dom';
import { setOpenActivity } from '../Store/ui/reader';
import { edit as editActivity, byBook, remove as deleteActivity } from '../Store/api/activities';
import MediaComponent from './activity/MediaComponent';

const Activity = ({
  mode = 'assign',
  isCleared = false,
  activity,
  selectedParagraphs = [],
  from = '',
  pickLib,
  scrollTo = () => {},
  selectedSections = [],
  index,
  setHighlightedParagraph,
  setGreyedPharagraphs,
  setHighlightedSection,
  setGreyedItem,
  disableClose = 'false',
  setPreviewActivity = (v) => {},
  isNew,
  setIsDraggingActivity = () => {},
  setDraggedActivityPosition = () => {},
  setDraggedActivity = () => {},
  isDraggingActivity,
  greyedItemSetter = () => {},
  highlightedParagraph = () => {},
  spreadActivitiesSetter = () => {},
  setHighlightedIndexes = () => {},
  setDraggedOver = () => {},
  bookId,
  setNewActivities,
  test,
}) => {
  const { openActivity } = useSelector((state) => state.ui.reader.reader);
  const [isExpanded, setIsExpanded] = useState(false);

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { chapters } = useSelector((state) => state.entities.book);
  const templates = useSelector((state) => state.ui.templates);
  const [editing, setEditing] = useState(false);
  const [spreadQuestions, setSpreadQuestions] = useState([]);
  const navigate = useNavigate();
  const [editedActivity, setEditedActivity] = useState({
    ...activity,
    score: Number(activity.score),
    questions: activity.questions.map((q) => ({
      ...q,
      ['difficulty']: q.difficulty || 1,
    })),
  });
  const elRef = useRef(null);

  const handleQuestionLevelMedia = (fileUrl, qIndex, mediaIndex) => {
    const newActivity = JSON.parse(JSON.stringify(activity));

    // first step to filter question by index
    let question = newActivity.questions.find((_, indx) => indx === qIndex);
    // run map on question mediaList and add media at mediaIndex
    if (question.mediaList.length)
      question = question.mediaList((prev) =>
        prev.map((item, i) => (i === mediaIndex ? { ...item, url: fileUrl } : item))
      );
    else {
      question.mediaList.push({ url: fileUrl });
    }

    setNewActivities((oldAct) =>
      oldAct.map((a, ai) =>
        ai !== qIndex
          ? a
          : {
              ...a,
              questions: a.questions.map((q, qi) => (qi !== qIndex ? q : question)),
            }
      )
    );
  };

  useEffect(() => {
    setEditedActivity({
      ...activity,
      score: Number(activity.score),
      questions: activity.questions.map((q) => ({
        ...q,
        difficulty: q.difficulty || 1,
      })),
    });
  }, [activity]);

  useEffect(() => {
    setEditedActivity({ ...activity, score: Number(activity.score) });
  }, [activity]);
  useEffect(() => {
    if (openActivity._id === activity._id) {
      setIsExpanded(true);
      setEditing(true);
    }
  }, [openActivity, activity._id]);
  const autoResize = (e) => {
    e.target.style.height = '22px'; // Reset the height initially
    e.target.style.height = `${e.target.scrollHeight}px`; // Adjust height based on content
  };

  const setActivity = () => {
    scrollTo(activity);
    const section = activity.section;
    const chapter = activity.chapter;
    const paragraph =
      activity.paragraphs && activity.paragraphs.length ? activity.paragraphs[0] : null;
    // const chapIndex = book.chapters.findIndex((e) => e._id === chapter);
    // if (chapIndex >= 0) {
    //   const secIndex = book.chapters[chapIndex].sections.findIndex(
    //     (e) => e._id === section
    //   );
    //   if (chapIndex >= 0) dispatch(setChapter(chapIndex));
    //   if (secIndex >= 0) dispatch(setSection(secIndex));
    //   if (!paragraph) {
    //     scroll(secIndex, chapIndex);
    //   } else {
    //     scrollToParagraph(activity.chapter, activity.section, paragraph);
    //   }
    // }
  };
  useEffect(() => {
    setIsExpanded(false);
  }, [isCleared]);

  const spreadQuestionsSetter = (i) => {
    if (spreadQuestions.includes(i)) {
      setSpreadQuestions(spreadQuestions.filter((e) => e !== i));
    } else {
      setSpreadQuestions([...spreadQuestions, i]);
    }
  };
  useEffect(() => {
    setEditedActivity((old) => ({
      ...old,
      score: editedActivity.questions.reduce((a, b) => {
        return a + b.score;
      }, 0),
    }));
  }, [editedActivity.questions]);

  const setDifficulty = (index, value) => {
    const question = editedActivity.questions[index];
    let score = question.score;
    switch (question.type) {
      case 'mcqs':
        score = value === 1 ? 1 : value === 2 ? 2 : 4;
        break;
      case 'blanks':
        score = value === 1 ? 0.5 : value === 2 ? 1 : 2;
        break;
      case 'fr':
        score = value === 1 ? 3 : value === 2 ? 6 : 12;
        break;
      case 'sa':
        score = value === 1 ? 1.5 : value === 2 ? 3 : 6;
        break;
      case 'truefalse':
        score = value === 1 ? 0.5 : value === 2 ? 1 : 2;
        break;
      default:
        score = value === 1 ? 0.25 : value === 2 ? 0.5 : 1;
        break;
    }
    setEditedActivity((act) => ({
      ...act,
      questions: act.questions.map((q, i) =>
        i === index ? { ...q, difficulty: value, score: score } : q
      ),
    }));
  };
  useEffect(() => {}, [activity.questions]);
  const types = {
    mcqs: 'multiple choice',
    fr: 'long response',
    truefalse: 'true and false',
    matching: 'matching',
    blanks: 'fill in the blanks',
    // mix: "mix type",
    sa: 'short response',
    or: 'order list',
  };
  const chaptersMap = chapters.reduce((acc, curr) => {
    acc[curr._id] = curr;
    return acc;
  }, {});

  const order = chaptersMap[activity.chapter] ? chaptersMap[activity.chapter].order : '';
  const chapter = chaptersMap[activity.chapter];
  const sectionIndex = chapter
    ? chapter.sections.findIndex((e) => e._id === activity.section)
    : -1;

  const editQuestion = (e, fIndex) => {
    const { name, value } = e.target;

    setEditedActivity((old) => {
      return {
        ...old,
        questions: old.questions.map((q, i) =>
          i === fIndex ? { ...q, [name]: value, isNew: false } : q
        ),
      };
    });
  };
  const editQuestionScore = (value, fIndex) => {
    setEditedActivity((old) => {
      return {
        ...old,
        questions: old.questions.map((q, i) =>
          i === fIndex
            ? {
                ...q,
                score: isNaN(Number(q.score) + value)
                  ? 1
                  : Number(q.score) + value >= 1
                  ? Number(q.score) + value
                  : Number(q.score),
                isNew: false,
              }
            : q
        ),
      };
    });
  };
  const deleteQuestion = (fIndex) => {
    setEditedActivity({
      ...editedActivity,
      questions: editedActivity.questions.filter((q, i) => i !== fIndex),
    });
  };

  const closeQuestion = (index) => {
    setEditedActivity((old) => {
      return {
        ...old,
        questions: old.questions.map((q, i) => (i === index ? { ...q, isNew: false } : q)),
      };
    });
  };
  const handleShare = () => {
    setEditedActivity((old) => {
      return {
        ...old,
        isShared: !old.isShared,
      };
    });
  };
  // const handleMediaUpload = (fileUrl, mediaIndex) => {
  //   setMediaList((prev) =>
  //     prev.map((item, i) => (i === mediaIndex ? { ...item, url: fileUrl } : item))
  //   );
  // };

  const handleMediaUpload = (fileUrl) => {
    setEditedActivity((prev) => ({
      ...prev,
      activityInstructionUrl: fileUrl,
    }));
  };

  const setDesc = (e) => {
    setNewActivities((old) =>
      old.map((a, i) =>
        i !== index
          ? a
          : {
              ...a,
              description: e.target.value,
            }
      )
    );
  };

  useEffect(() => {
    const handleClick = (event) => {
      if (elRef.current && !elRef.current.contains(event.target)) {
        // Clicked outside of the wrapperRef
        // setOpenMedia(false);
      }
    };

    // Attach the event listener to the body when the component mounts
    document.body.addEventListener('click', handleClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <div id={activity._id}>
      {isExpanded ? (
        <div className='activity-wraper activity-element'>
          <div className={editing ? ' spread-activity editing ' : 'spread-activity '} key={index}>
            <div
              className='box_detail edite_box mb-12'
              style={{ marginBottom: editing ? '0px' : '' }}
            >
              <h5>
                {activity.graded === 'teacher' ? 'teacher-graded' : 'auto-graded'}

                <span className='p-relative d-flex  align-items-center'>
                  {activity.createdBy === user._id && (
                    <Fragment>
                      {from !== 'dashboard' && mode !== 'assign' && (
                        <a
                          href='#!'
                          className='cursor del'
                          onClick={(e) => {
                            e.stopPropagation();
                            const sure = window.confirm(
                              'Do you really want to delete this activity?'
                            );
                            if (sure) {
                              dispatch(
                                deleteActivity({
                                  id: activity._id,
                                  onSuccess: (res) => {
                                    if (mode === 'create') setPreviewActivity(false);
                                    dispatch(
                                      byBook({
                                        id: bookId,
                                        onSuccess: (res) => {
                                          setGreyedItem('');
                                          setHighlightedParagraph('');
                                          setHighlightedSection('');
                                          setGreyedPharagraphs([]);
                                          setHighlightedIndexes([]);
                                          setDraggedOver(null);
                                        },
                                      })
                                    );
                                  },
                                })
                              );
                            }
                          }}
                        >
                          <u> delete</u>
                        </a>
                      )}
                      <a
                        className='cursor'
                        onClick={(e) => {
                          e.preventDefault();
                          if (mode === 'assign') {
                            dispatch(setOpenActivity(activity));
                            navigate('/create/' + activity.book);
                          } else {
                            spreadActivitiesSetter(activity._id);
                            setEditing(true);
                          }
                        }}
                      >
                        {mode === 'create' ? (editing ? 'editing' : 'edit') : 'edit in create'}
                      </a>
                    </Fragment>
                  )}
                  {mode === 'assign' && (
                    <img src={Diamond} alt='g' style={{ marginRight: '12px' }} />
                  )}
                  <a style={{ position: 'relative' }}>
                    {/*<img
                  src={user._id !== activity.createdBy && !editing ? profilePic : userPic}
                  alt=""
                  className="activity-profile-pic"
                    />*/}
                    <div className='profile_placeholder'>
                      {activity.owner?.image ? (
                        <img
                          src={activity.owner.image}
                          alt='profile_photo'
                          style={{
                            width: '18px',
                            height: '18px',
                            objectFit: 'cover',
                            borderRadius: '50%',
                          }}
                        />
                      ) : (
                        <p>
                          {activity.owner?.firstName?.[0]}
                          {activity.owner?.lastName?.[0]}
                        </p>
                      )}
                    </div>
                    {user._id !== activity?.owner?._id && !editing && (
                      <img src={star} alt='profile' className='golden-star-spread-activity' />
                    )}
                  </a>
                </span>
              </h5>
              <h2>
                <div
                  style={{ textDecoration: 'underline' }}
                  onClick={(e) => {
                    scrollTo(activity);
                  }}
                  className='cursor'
                >
                  {' '}
                  {'chapter'} {activity?.chapter?.order}
                  {' section'} {activity?.section?.order}
                  {/* {sectionIndex > -1 ? ", section " + (sectionIndex + 1) : ""} */}
                </div>

                <div className='date-hero'>
                  <u>
                    {activity.assigned && activity.assignedDate
                      ? `Due ${new Date(activity.assignedDate)
                          .toLocaleDateString('en-US')
                          .replace(/\//g, '.')}`
                      : 'Unassigned'}
                  </u>
                </div>
              </h2>
              {editing ? (
                <textarea
                  type='title'
                  style={{ resize: 'none' }}
                  value={editedActivity.title}
                  className='activity-title-textarea'
                  ref={(el) => (el ? autoResize({ target: el }) : null)}
                  onChange={(e) => {
                    setEditedActivity({
                      ...editedActivity,
                      title: e.target.value,
                    });
                    autoResize(e);
                  }}
                />
              ) : (
                <h3>{editedActivity.title}</h3>
              )}
              <div className='spread-activity-details' style={{ marginTop: '4px' }}>
                <b>
                  {editedActivity?.questions?.reduce((a, b) => {
                    return a + (isNaN(Number(b.score)) ? 0 : Number(b.score));
                  }, 0)}
                </b>{' '}
                pts | {editedActivity?.questions?.length} questions
              </div>
              {editing ? (
                <>
                  <textarea
                    style={{ resize: 'none' }}
                    // name="description"
                    placeholder='Name your activity'
                    className='activity-description-textarea'
                    value={editedActivity.description}
                    ref={(el) => (el ? autoResize({ target: el }) : null)}
                    onChange={(e) => {
                      setEditedActivity({
                        ...editedActivity,
                        description: e.target.value,
                      });
                      autoResize(e);
                    }}
                  />

                  <MediaComponent media={editedActivity} level='activity' />
                </>
              ) : (
                <>
                  {editedActivity?.description && (
                    <p className='spread-activity-description'>{editedActivity?.description}</p>
                  )}
                  {editedActivity?.activityInstructionUrl && (
                    <MediaComponent media={editedActivity} level='activity' />
                  )}
                </>
              )}
            </div>
            {editedActivity?.questions?.map((question, qIndex) => (
              <>
                <div className={`edit_option mb-12 ${editing ? 'bg_white' : ''}`} key={qIndex}>
                  <Fragment>
                    <NewQuestion
                      setDifficulty={setDifficulty}
                      question={question}
                      activityScore={editedActivity.score}
                      spreadQuestions={spreadQuestions}
                      spreadQuestionsSetter={spreadQuestionsSetter}
                      activity={editedActivity}
                      index={qIndex}
                      actIndex={index}
                      navigate={navigate}
                      editing={editing}
                      closeQuestion={closeQuestion}
                      editQuestion={editQuestion}
                      editQuestionScore={editQuestionScore}
                      types={types}
                      setQuestions={setEditedActivity}
                      deleteQuestion={deleteQuestion}
                      bookId={bookId}
                      mode={mode}
                      handleQuestionLevelMedia={handleQuestionLevelMedia}
                      setNewActivities={setNewActivities}
                    />
                  </Fragment>
                </div>
              </>
            ))}
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <div
                className='cursor activity-open-btn'
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  setIsExpanded((old) => !old);
                }}
              >
                {isExpanded && 'Close'} <img src={arrowUp} alt='arrow' />
              </div>
            </div>
            {editing && (
              <div className='add_plus'>
                <p className='mt-3'>
                  <img src={plus} alt='plus' className='mr-3' />
                  Add a{' '}
                  <div className='Multiplechoice_wrap' style={{ display: 'inline-flex' }}>
                    <div className='btn-group'>
                      <button
                        type='button'
                        className='btn btn-link dropdown-toggle'
                        data-bs-toggle='dropdown'
                        aria-expanded='false'
                        style={{
                          margin: '0 4px',
                        }}
                      >
                        multiple-choice
                      </button>
                      <ul className='dropdown-menu cursor'>
                        {templates?.map((temp, tempIndex) => (
                          <li key={tempIndex}>
                            <a
                              href='#.'
                              className='dropdown-item crusor'
                              onClick={(e) => {
                                e.preventDefault();
                                setEditedActivity((old) => {
                                  return {
                                    ...old,
                                    questions: [
                                      ...old.questions,
                                      {
                                        type: temp.type,
                                        isNew: true,
                                        text: '',
                                        description: '',
                                        score:
                                          temp.type === 'mcqs'
                                            ? 1
                                            : temp.type === 'truefalse'
                                            ? 0.5
                                            : temp.type === 'fr'
                                            ? 3
                                            : temp.type === 'sa'
                                            ? 1.5
                                            : temp.type === 'blanks'
                                            ? 0.5
                                            : 0.25,
                                        difficulty: 1,
                                        blanksBank: [],
                                        questionBank: [],
                                        options:
                                          temp.type === 'mcqs' ||
                                          temp.type === 'truefalse' ||
                                          temp.type === 'matching' ||
                                          temp.type === 'multiselect' ||
                                          temp.type === 'orderlist'
                                            ? []
                                            : [],
                                      },
                                    ],
                                  };
                                });
                              }}
                            >
                              {temp.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>{' '}
                  question to this activity
                </p>
                <button
                  className='bnt_save'
                  onClick={(e) => {
                    e.stopPropagation();

                    let error = '';
                    if (!editedActivity.title) error = 'Title is required.';

                    if (!editedActivity.questions || !Array.isArray(activity.questions)) {
                      error = 'There must be at least one question.';
                    } else {
                      for (let qIndex = 0; qIndex < editedActivity.questions.length; qIndex++) {
                        const question = editedActivity.questions[qIndex];
                        if (!question.text) {
                          error = 'Each question must have a text/title?';
                          break;
                        }
                        if (question.type == 'mcqs') {
                          if (
                            !question.options ||
                            !Array.isArray(question.options) ||
                            question.options.length <= 1
                          ) {
                            error = 'MCQs questions must have more than one options.';
                            break;
                          } else {
                            let optionError = true;
                            for (
                              let optionIndex = 0;
                              optionIndex < question.options.length;
                              optionIndex++
                            ) {
                              const option = question.options[optionIndex];
                              if (
                                !option.text &&
                                !['image', 'audio', 'video'].includes(option.type)
                              ) {
                                error = 'Each option must have some text.';
                                break;
                              }
                              if (option.isCorrect) {
                                optionError = false;
                              }
                            }
                            if (optionError)
                              error =
                                'There must be at least one correct option in each MCQs question.';
                          }
                        }
                      }
                    }

                    if (!editedActivity.activityInstructionsType) {
                      editedActivity.activityInstructionsType = 'text';
                    }
                    if (!editedActivity.activityInstructionsTitle) {
                      editedActivity.activityInstructionsTitle = '';
                    }
                    if (!editedActivity.activityInstructionUrl) {
                      editedActivity.activityInstructionUrl = '';
                    }

                    if (error !== '') {
                      alert(error);
                      return;
                    }
                    const id = editedActivity._id;
                    delete editedActivity._id;
                    if (!editedActivity.assignedDate) {
                      delete editedActivity.assignedDate;
                    }
                    if (!editedActivity.section) {
                      delete editedActivity.section;
                    }
                    if (typeof editedActivity.chapter === 'object') {
                      editedActivity.chapter = editedActivity.chapter._id;
                    }
                    if (typeof editedActivity.section === 'object') {
                      editedActivity.section = editedActivity.section._id;
                    }
                    if (editedActivity.hasOwnProperty('isDeleted')) {
                      delete editedActivity.isDeleted;
                    }
                    if (editedActivity.hasOwnProperty('isBookDeleted')) {
                      delete editedActivity.isBookDeleted;
                    }
                    if (editedActivity.hasOwnProperty('createdAt')) {
                      delete editedActivity.createdAt;
                    }
                    if (editedActivity.hasOwnProperty('__v')) {
                      delete editedActivity.__v;
                    }
                    delete editedActivity.chap;
                    delete editedActivity.classSections;
                    dispatch(
                      editActivity({
                        id: activity._id,
                        body: {
                          ...editedActivity,
                          sections: selectedSections,
                          paragraphs: selectedParagraphs,
                          ...(selectedSections?.length > 0 && { section: selectedSections?.[0] }),
                          questions: editedActivity.questions.map(({ isNew, ...rest }) => rest),
                          owner: editedActivity.owner._id,
                        },
                        onSuccess: (res) => {
                          scrollTo(null);
                          setIsExpanded(false);
                          setEditing(false);
                          dispatch(
                            byBook({
                              id: bookId,
                              onSuccess: (res) => {},
                            })
                          );
                        },
                        onError: (err) => {
                          alert(err.response?.data?.message);
                        },
                      })
                    );

                    setEditing(false);
                  }}
                >
                  {from === 'dashboard' ? 'Save' : 'Save and link to highlighted section dddd'}
                </button>
                <div className='share iagree_radio blanks-opt'>
                  <input
                    className=''
                    type='checkbox'
                    id='share-activity'
                    checked={editedActivity.isShared}
                    onChange={handleShare}
                  />
                  <label htmlFor='share-activity'>
                    <div>Share activity on Greyled </div>
                  </label>
                </div>
              </div>
            )}
            {!editing && isNew && (
              <div className=' iagree_radio blanks-opt '>
                <input
                  className=''
                  type='checkbox'
                  id='share-activity'
                  checked={editedActivity.isShared}
                  onChange={handleShare}
                />

                <label htmlFor='share-activity'>
                  <div>Share activity on Greyled</div>
                </label>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          className='activity-wraper activity-element'
          style={{ cursor: 'move' }}
          onMouseDown={(e) => {
            // if (!showCalendar) return;
            if (user._id !== activity.createdBy) return;
            setIsDraggingActivity(true);
            setDraggedActivityPosition({
              top: (e.clientY / window.innerHeight) * 100,
              left: (e.clientX / window.innerWidth) * 100,
            });
            setDraggedActivity(activity);
          }}
          onMouseUp={(e) => {
            if (isDraggingActivity) {
              setIsDraggingActivity(false);
            }
          }}
        >
          <MCQsActivity
            disableClose={disableClose}
            mode={mode}
            setIsExpanded={setIsExpanded}
            isExpanded={isExpanded}
            activity={activity}
            scrollTo={scrollTo}
            setActivity={setActivity}
            greyedItemSetter={greyedItemSetter}
            highlightedP={highlightedParagraph}
            spreadActivitiesSetter={spreadActivitiesSetter}
            editing={editing}
            editActivity={editedActivity}
            setEditing={setEditing}
            pickLib={pickLib}
            setHighlightedIndexes={setHighlightedIndexes}
            setDraggedOver={setDraggedOver}
          />
        </div>
      )}
    </div>
  );
};

const MCQsActivity = ({
  activity,
  mode,
  disableClose,
  setHighlightedIndexes,
  setDraggedOver,
  setIsExpanded,
  highlightedP,
  spreadActivitiesSetter,
  setActivity,
  isExpanded,
  scrollTo,
  greyedItemSetter,
  editing,
  setEditing,
  editActivity,
  pickLib = 'create',
}) => {
  const { questions } = editActivity;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  // const uniqueTypes = [...new Set(questions?.map(({type}) => type))];
  const { chapters } = useSelector((state) => state.entities.book);
  const { user } = useSelector((state) => state.auth);
  const { book } = useSelector((state) => state.entities);

  const chaptersMap = chapters.reduce((acc, curr) => {
    acc[curr._id] = curr;
    return acc;
  }, {});

  const order = chaptersMap[activity.chapter] ? chaptersMap[activity.chapter]?.order : '';
  const chapter = chaptersMap[activity.chapter];
  const sectionIndex = chapter
    ? chapter.sections.findIndex((e) => e._id === activity.section)
    : -1;
  return (
    <div
      className={`box_detail box_shdow activity_question activity-element ${
        activity?.paragraphs?.includes(highlightedP) ? 'highlight' : ''
      }`}
      key={activity.chapter + activity.section}
      onClick={(e) => {
        scrollTo(activity);
        e.stopPropagation();
      }}
    >
      <h5 className='' style={{ position: 'relative' }}>
        {activity.graded === 'auto' ? 'auto-graded' : 'teacher-graded'}

        <div className='p-relative d-flex  align-items-center'>
          {activity.createdBy === user._id && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              className='cursor'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (mode === 'assign') {
                  dispatch(setOpenActivity(activity));
                  navigate('/create/' + activity.book);
                } else {
                  scrollTo(activity, true);
                  setIsExpanded(true);
                  setEditing(true);
                }
              }}
            >
              {mode === 'create' ? 'edit' : 'edit in create'}
            </a>
          )}

          {mode === 'assign' && <img src={Diamond} alt='g' style={{ marginRight: '12px' }} />}
          <div className='p-relative'>
            <div className='profile_placeholder'>
              {activity.owner?.image ? (
                <img
                  src={activity.owner.image}
                  alt='profile_photo'
                  style={{
                    width: '18px',
                    height: '18px',
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                />
              ) : (
                <p>
                  {activity.owner?.firstName[0]}
                  {activity.owner?.lastName[0]}
                </p>
              )}
            </div>
            {((activity.owner && activity.owner._id === book.owner) ||
              activity.createdBy === book.owner) && (
              <img src={star} alt='profile' className='golden-star-spread-activity' />
            )}
          </div>
        </div>
      </h5>
      <h2
        className='cursor '
        style={{ justifyContent: 'space-between', display: 'flex' }}
        onClick={(e) => {
          e.stopPropagation();
          setActivity();
          greyedItemSetter(activity);
        }}
      >
        <div style={{ textDecoration: 'underline' }}>
          {' '}
          chapter {activity?.chap?.order}{' '}
          {sectionIndex > -1 ? ', section ' + (sectionIndex + 1) : ''}
        </div>

        <div className='date-hero'>
          <u>
            {activity.assigned && activity.assignedDate
              ? `Due ${new Date(activity.assignedDate)
                  .toLocaleDateString('en-US')
                  .replace(/\//g, '.')}`
              : 'Unassigned'}
          </u>
        </div>
      </h2>
      <h3 className='event-less mb-0'>{editActivity.title}</h3>
      <p className='lh_16 event-less activity-description ' style={{ margin: '4px 0px' }}>
        {editActivity.description}
      </p>
      <div className='questions event-less'>
        {questions &&
          questions?.length > 0 &&
          (show ? questions : [questions[0]]).map((question, qI) => (
            <div key={qI}>{<h3 className='question_title event-less'>{question.text}</h3>}</div>
          ))}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '16px',
        }}
      >
        {!show && questions && questions?.length > 1 ? (
          <div
            className='cursor more_questions'
            onClick={(e) => {
              e.stopPropagation();
              setShow(true);
            }}
          >
            <span className=''>+{questions && questions?.length - 1}</span> other tempers
          </div>
        ) : (
          <div></div>
        )}

        <div
          className='cursor activity-open-btn'
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setActivity();
            greyedItemSetter(activity);
            setIsExpanded((old) => !old);
            spreadActivitiesSetter(activity._id);
            if (isExpanded) {
              setHighlightedIndexes([]);
              setDraggedOver(null);
            }
          }}
        >
          {!isExpanded && 'Open'} <img src={arrow} alt='arrow' />
        </div>
      </div>
    </div>
  );
};

export default Activity;
